export function patchURLArrays(query: string, updates: Record<string, string[]>, resetKeys: string[] = []): URLSearchParams {
    const params = new URLSearchParams(query);
    for (const key of resetKeys) params.delete(key);
    for (const [key, values] of Object.entries(updates)) {
        params.delete(key);
        for (const value of values) {
            if (value.trim()) params.append(key, value.trim());
        }
    }
    return params;
}
